<template>
  <div class="web-text-view">
    <textarea ref="input" :value="text" :readonly="!editable" :maxlength="maxLength" @input="emit" @blur="$emit('blur')" @focus="$emit('focus')"></textarea>
  </div>
</template>

<script>

const modelProp = 'text'
const modelEvent = 'textChange'

export default {
  model: {
    prop: modelProp,
    event: modelEvent
  },
  props: {
    text: {
      default: ''
    },
    secure: {
      type: Boolean,
      default: false
    },
    keyboardType: {
      type: String
    },
    maxLength: {
      type: Number
    },
    editable: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    emit (event) {
      this.$emit(modelEvent, {
        object: this,
        eventName: modelEvent,
        oldValue: this.text,
        propertyName: modelProp,
        value: this.maxLength ? event.target.value.substr(0, this.maxLength) : event.target.value
      })
    },
    focus () {
      this.$refs.input.focus()
    }
  }
}

</script>

<style lang="scss" scoped>

html {
  .web-text-view {
    height: 100%;
    position: relative;
  }

  .web-text-view textarea {
    padding: inherit;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: transparent;
    resize: none;
    white-space: pre-wrap; /* Preserve spaces and line breaks */
    word-wrap: break-word; /* Allow long words to break */
  }
}

</style>